import { FC, useState, useEffect, } from 'react';
// 组件
import SortList from './subpage/sortList';
import SortItem from './subpage/sortItem';
// 常量
import { SortEnd, SortEvent, SortEventWithTag, SortOver, SortStart } from '@yonboo/react-sortable-hoc';
import { SortElementProps, SortOption } from './interface';
import './style.less';

/** 拖拽 */
const SortElement: FC<SortElementProps> = props => {
  const { items: outItems, onSortEnd, axis, dragHandle, ...restProps } = props;
  const [items, setItems] = useState<SortOption[]>();
  useEffect(() => {
    setItems(outItems);
  }, [outItems]);
  /** 排序结束时的回调 */
  const handleSortEnd = (sort: SortEnd, event: SortEvent) => {
    if (!items) return;
    const { oldIndex, newIndex, } = sort;
    const newItems = [...items];
    const startItem = newItems[oldIndex];
    const endItem = newItems[newIndex];
    newItems[newIndex] = startItem;
    newItems[oldIndex] = endItem;
    setItems(newItems);
    onSortEnd?.(sort, event);
  };

  return (
    // @ts-ignore
    <SortList
      axis={axis}
      sortAxis={axis}
      dragHandle={dragHandle}
      onSortEnd={handleSortEnd}
      {...restProps}
      useDragHandle
    >
      {items?.map((item, index) => (
        <SortItem
          key={item.key}
          index={index}
          // @ts-ignore
          item={item}
          dragHandle={dragHandle}
        />
      ))}
    </SortList>
  );
};

SortElement.defaultProps = {
  helperClass: 'yb-sort-item-move'
};

export default SortElement;
